/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type PlaylistGetTracksStatus =
  (typeof PlaylistGetTracksStatus)[keyof typeof PlaylistGetTracksStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistGetTracksStatus = {
  cancelled: "cancelled",
  completed: "completed",
  failed: "failed",
  generating: "generating",
  metadata_ready: "metadata_ready",
  music_generating: "music_generating",
  paused: "paused",
  pending: "pending",
  published: "published",
} as const;
